import type { ShapeAppraisalDocument } from "@aprao/model/src/shapes/ShapeAppraisal.js";
import type { ShapeProjectDocument } from "@aprao/model/src/shapes/ShapeProject.js";

export const formatReportTitle = (
  project: ShapeProjectDocument,
  appraisal: ShapeAppraisalDocument,
) =>
  [project.siteAddress, appraisal.title]
    .filter((str) => str.trim().length !== 0)
    .join(" - ");
